"use client"

import type { CSSProperties } from "react"
import type { CareerPricingView } from "./useCareerPricing"

// Honest introductory-offer emphasis, shown only while the launch promo is active.
// No fake urgency (no countdowns, no fake scarcity): a real "Launch Special · Save N%"
// pill and a real "lock in this price while you stay subscribed" incentive line.

export function LaunchBadge({ pricing, style }: { pricing: CareerPricingView; style?: CSSProperties }) {
  if (!pricing.promoActive) return null
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: "var(--type-2xs)", fontWeight: 800, letterSpacing: "0.06em", textTransform: "uppercase", padding: "4px 10px", borderRadius: "var(--radius-pill)", background: "var(--accent)", color: "var(--on-accent, #fff)", whiteSpace: "nowrap", ...style }}>
      {pricing.promoName} · Save {pricing.savings.pct}%
    </span>
  )
}

export function LaunchLockLine({ pricing, style }: { pricing: CareerPricingView; style?: CSSProperties }) {
  if (!pricing.promoActive) return null
  return (
    <span style={{ fontSize: "var(--type-xs)", color: "var(--accent-text)", fontWeight: 600, lineHeight: 1.5, ...style }}>
      Introductory price, {pricing.savings.perWeekLabel}/week off. Lock in {pricing.launch.label}/week now and keep it as long as you stay subscribed.
    </span>
  )
}
